import request from '@/utils/request';
import { encryptedData } from '@/utils/encrypt';
import { loginRSA } from '@/config';
export async function login(data) {
  if (loginRSA) {
    data = await encryptedData(data);
  }
  data.type = 'Tenant';
  return axios.post(`/api/identity/TokenAuth/AdministratorAuthenticate`, data);
}
export async function socialLogin(data) {
  if (loginRSA) {
    data = await encryptedData(data);
  }
  return request({
    url: '/socialLogin',
    method: 'post',
    data
  });
}
export function logout() {
  // return request({
  //   url: '/api/identity/TokenAuth/Logout',
  //   method: 'get',
  // })
}
export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data
  });
}